import moment from 'moment';
import { getLocale, history, useIntl } from 'umi';

export const NONE_TEXT = ['none', 'ninguna', 'non'];

export const getCurrentLocale = () => {
  const locale = getLocale();
  return locale.split('-')[0];
};

export const QUESTIONS_KEY:Record<string, string> = {
  SELECT_LANGUAGE: 'languagePreference',
  ADDITIONAL_PERSON: 'anyAdditionalPerson',
  CONTAGIONS: 'contagions',
  CREATE_A_NEW_QUOTE: 'reassessmentQuote',
  STAFF_MEMBER_NAME: 'staffMemberName',
  IS_STAFF: 'isStaff',
  RELATIONSHIP: 'relationship',
  CONTACT_TIME_DATE: 'contactTimeDate',
  CONTACT_TIME_DATE_TIME: 'contactTimeDatetime',
  CONTACT_TIME_DATE_DATE: 'contactTimeDatedate',
  READY_TO_SCHEDULE_HOME_APPT: 'readyToScheduleHomeAppt',
  TOILETING: "toileting",
  ADDITIONAL_NOTES: "additionalNotes",
  RECIPIENT_GENDER: "recipientGender",
  PET_CARE: "petCare",
  PET_CARE_OTHER: 'petCareOther',
  RECIPIENT_NAME: 'recipientName',
  RECIPIENT_EMAIL: 'recipientEmail',
  RECIPIENT_PHONE: 'recipientPhoneNumber',
  GENERAL_CONCERNS_ALL: 'generalConcernsAll',
  RECIPIENT_DOB: "recipientDob",
  RECIPIENT_DOB_AGE: "recipientDobAge",
  BATHING: "bathing",
  TRANSFERS: "transfers",
  TRANSFERS_OTHER: "transfersOther",
  ALLOW_CONTACT: "allowContact",
  FILLER_EMAIL: "fillerEmail",
  FILLER_PHONE_NUMBER: "fillerPhoneNumber",
  FILLER_NAME: "fillerName",
  CONTACT_TIME_DATE_EMAIL: "contactTimeDateemail",
  CONTACT_TIME_DATE_NAME: "contactTimeDatename",
  CONTACT_TIME_DATE_PHONE: "contactTimeDatephone",
  PROPERTY_TYPE: "propertyType",
  SERVICES_PROVIDED: 'servicesProvided',
  NUTRITION: 'nutrition',
  INJURIES: 'injuries',
  FALLS: 'falls',
  ER_VISITS: 'erVisits',
  HOSPITAL_ADMISSIONS: 'hospitalAdmissions',
  MEDICAL_CONDITIONS: 'medicalConditions',
  COMPANION_SITTERALL: 'companionSitterAll',
  COMPANION_SITTERALL_OTHER:'companionSitterAllOther',
  RECIPIENT_HEIGHT: "recipientHeight",
  RECIPIENT_WEIGHT: "recipientWeight",
  SERVICES_START_DATE:"serviceStartDate",
  TREATMENTS:"treatments",
  DAYS_REQUIRED_SERVICE: 'daysRequiredService',
  HOURS_NEED: 'hoursNeeded',
  CALLER_NAME: 'callerName',
  CALLER_PHONE_NUMBER: 'callerPhoneNumber',
  CALLER_EMAIL: 'callerEmail',
  DECISION_MAKER: 'decisionMaker',
  PATIENT_CALLING_FOR: 'patientCallingFor',
  TRANSFER_ASSIST: 'transferAssist',
  REFERRAL_SOURCE_NAME: 'referralSourceName',
  HAS_RECIPIENT_EMAIL:"hasRecipientEmail",
  MEDICAL_DECISION_MAKER: 'medicalDecisionMaker',
  FINANCIAL_DECISION_MAKER :'financialDecisionMaker',
  PRIMARY_COORDINATOR: 'primaryCoordinator',
  PRIMARY_EMERGENCY_CONTACT: 'primaryEmergencyContact',
  AMBULATION: 'ambulation',
  ASSISTIVE_DEVICES: 'assistiveDevices',
  CARE_RECIPIENT_CONTACT_CONSENT: 'care_recipient_contact_consent',
  RECIPIENT_AWARENESS: 'recipientAwareness',
  RECIPIENT_PREFERRED_CONTACT_METHOD: 'recipientPreferredContactMethod',
  SERVICE_ADDRESS: 'serviceAddress',
  SMOKING: 'smoking',
  OXYGEN_IN_HOME: 'oxygen_in_home',
  HOME_ENVIRONMENT_FINAL_NOTES: 'homeEnvironmentFinalNotes',
  HOME_SAFETY_CONCERN:'homeSafetyConcern',
  CHEWING_SWALLOWING: 'chewingSwallowing'
};
export const NOT_INPUT_OTHER = [
  QUESTIONS_KEY.BATHING,
  QUESTIONS_KEY.SERVICES_PROVIDED,
  QUESTIONS_KEY.READY_TO_SCHEDULE_HOME_APPT,
  QUESTIONS_KEY.RELATIONSHIP,
  QUESTIONS_KEY.PET_CARE,
  QUESTIONS_KEY.GENERAL_CONCERNS_ALL,
  QUESTIONS_KEY.TRANSFERS,
  QUESTIONS_KEY.NUTRITION,
];
export const QUESTION_KEY_UNCERTAIN_REQUIRE = [
  QUESTIONS_KEY.BATHING,
  QUESTIONS_KEY.NUTRITION,
  QUESTIONS_KEY.INJURIES,
  QUESTIONS_KEY.FALLS,
  QUESTIONS_KEY.ER_VISITS,
  QUESTIONS_KEY.HOSPITAL_ADMISSIONS,
  QUESTIONS_KEY.MEDICAL_CONDITIONS,
  QUESTIONS_KEY.COMPANION_SITTERALL,
  QUESTIONS_KEY.CHEWING_SWALLOWING

];

export const LANGUAGES_KEY:Record<string, string> = {
  '1': 'en-US',
  '2': 'es-ES',
  '3': 'fr-FR',
  en: 'en-US',
  es: 'es-ES',
  fr: 'fr-FR',
  'en-EN': 'en',
  'es-ES': 'es',
  'fr-FR': 'fr',
};

export const ADDITIONAL_PERSON_CATEGORY: Record<string, string> = {
  '0': '1st_recipient',
  '1': '1st_recipient',
  '2': 'minimal_care_2nd_recipient',
  '3': 'full_care_2nd_recipient',
};

export const CATEGORY_FOR_CONVERT_HISTORY_ANSWERS: Record<string, string> = {
  '1': '1st_recipient',
  '2': 'minimal_care_2nd_recipient',
  '3': 'full_care_2nd_recipient',
};

export const DEFAULT_CATEGORY_RECIPIENTS:string  = '1st_recipient';

export const TEST_CLIENT_ID = CLIENT_ID;

export const DEFAULT_QUOTE_CODE:string = 'itq3q9na';

export const DEFAULT_CLIENT_ID:string = 'demo';

export const RECIPIENTS:Record<string, string> = {
  '1st_recipient': '1stRecipient',
  full_care_2nd_recipient: '2ndRecipient',
  minimal_care_2nd_recipient: '2ndRecipient',
};

export const REMOVE_RECIPIENT: Record<string, string[]> = {
  full_care_2nd_recipient: ['minimal_care_2nd_recipient'],
  minimal_care_2nd_recipient: ['full_care_2nd_recipient'],
  '1st_recipient': ['minimal_care_2nd_recipient', 'full_care_2nd_recipient'],
};
export const animalNamesConstant: Record<string, string[]> = {
  en: ["Dogs", "Cats", "Birds", "Pigs", "Fish"],
  fr: ["Chiens",
    "Chats",
    "Oiseaux",
    "Porcins",
    "Poisson"],
  es: ["Perros",
    "Gatos",
    "Pájaros",
    "Cerdos",
    "Pescado"]
};
export const animalName: Record<string, string[]> = {
  en: ["Dog", "Cat", "Bird", "Pig", "Fish"],
  fr: ["Chien",
    "Chat",
    "Oiseaux",
    "Porcin",
    "Poisson"],
  es: ["Perro",
    "Gato",
    "Pájaro",
    "Cerdo",
    "Pescado"]
};
export const transfersInfo: string[] = ["Height", "Weight", "select"];
export const transfersUnit: Record<string, string> = {
  Height: "(inches)",
  Weight: "(lbs)"
}
export const SECONDARY_CARE: string[] = [
  'full_care_2nd_recipient',
  'minimal_care_2nd_recipient',
  'readyToScheduleHomeAppt',
];
export const GROUP_KEY_QUESTION_ONE: string[] = ['currentlyInHospitalOrRehab'];
export const GROUP_KEY_QUESTION_MULTI: string[] = ['isStaff', 'patientCallingFor', 'readyToScheduleHomeAppt',];
export const GROUP_KEY_QUESTION_ONE_COMMONAPP: string[] = ['currentlyInHospitalOrRehab', 'readyToScheduleHomeAppt'];
export const GROUP_KEY_QUESTION_MULTI_COMMONAPP: string[] = ['isStaff', 'patientCallingFor',];
export const QUESTION_REQUIRED: string[] = ['recipientPhoneNumber', 'recipientEmail'];
export const GROUP_KEY_QUESTION_MULTI_CHOICE: Record<string, string[]> = {
  transfers: ["3", "4", "5"], emergencyContactDecisionMaker: ["1", "3"]
}
export const GROUP_KEY_QUESTION_MULTI_CHOICE_V3 : Record<string, string[]> = {
  transfers: ["3", "4", "5"], emergencyContactDecisionMaker: ["1", "3"], falls:["2", "3", "4", "5"], petsInHome:['yes'], homeSafetyConcern: ['yes', 'not_sure']
}
export const getDynamicAnswerKey = (
  answersKeys: string[],
  questionKey: string,
  recipient = DEFAULT_CATEGORY_RECIPIENTS,
) => {
  return answersKeys.find(
    (key) => key.startsWith(`${recipient}/`) && key.endsWith(`/${questionKey}`)
  );
};

export const getDynamicAnswerValue = (
  answers: Record<string, any>,
  questionKey: string,
  recipient = DEFAULT_CATEGORY_RECIPIENTS,
) => {
  const key = getDynamicAnswerKey(Object.keys(answers), questionKey, recipient);
  return key ? answers[key] : undefined;
};

export const printPDF = (url: string) => {
  let iframe = document.getElementById('printPDF') as HTMLIFrameElement;
  if (!iframe) {
    iframe = document.createElement('iframe');
    iframe.id = 'printPDF';
    iframe.style.display = 'none';
    document.body.appendChild(iframe);
    iframe.onload = function () {
      setTimeout(function () {
        iframe.focus();
        iframe?.contentWindow?.print();
      }, 1);
    };
  }
  iframe.src = url;
};

export const SUFFIX_QUESTION_KEY = {
  OT: 'Other',
  '@UN': 'Uncertain',
};

export const OtherLabelText = () => {
  const intl = useIntl();
  return intl.formatMessage({
    id: 'app.settings.other',
  });
};

export const UncertainLabelText = () => {
  const intl = useIntl();
  return intl.formatMessage({
    id: 'app.settings.uncertain',
  });
};

export const SUFFIX_QUESTION_TEXT = {
  OT: OtherLabelText,
  '@UN': UncertainLabelText,
};
export const transText = (idText: string) => {
  const intl = useIntl();
  return intl.formatMessage({
    id: idText,
  });
}
export const isRenew = Object.keys(history.location.query || {}).includes('renew');

export const sortChoicesSelected = (choicesKey: string[], answers: string[]) => {
  if (typeof answers !== 'object' || !answers[0] || answers.length <= 1) return answers;
  return answers.sort((a, b) => choicesKey.indexOf(a) - choicesKey.indexOf(b));
};

export const isNoneOption = (option: API.Choice) =>
  (!!option?.name && NONE_TEXT.includes(option?.name?.toLowerCase())) || option?.extraData?.isSelectNone || option?.isSelectNone;

export const isSelectNone = (options: API.Choice[], answersKey: string | string[]) => {
  return options.some(
    (o: API.Choice) =>
      isNoneOption(o) && (answersKey === o.key || (answersKey?.length > 0 && answersKey?.includes(o.key))),
  );
}
export const objectHasEmptyProperties = (object: any) => {
  for (const key of Object.keys(object)) {
    if (!Boolean(object[key])) {
      return true;
    }
  }
  return false;
};
export const formatToCurrency = (value:number, market:string | undefined) => {
  if(market == 'CA') return "$" + value.toFixed(2).replace(/\d(?=(\d{3})+\.)/g, "$&,") + ' CAD';
  return "$" + value.toFixed(2).replace(/\d(?=(\d{3})+\.)/g, "$&,");
};
export const FORMAT_DATE = 'MM/DD/YYYY';
export const FORMAT_DATE_CA = 'YYYY/MM/DD';
export const getFormatDateTime = (market='US')=>{
 return market == 'CA'? 'YYYY/MM/DD h:mm:ss a' :'MM/DD/YYYY h:mm:ss a';
};
export const getFormatDate = (market = "US") => {

  if (market === "CA") {
    return FORMAT_DATE_CA;
  }
  return FORMAT_DATE;
}
export const validateAutoFillDate = (value: string, market = "US") => {
  const FORMAT_DATE_INPUT = getFormatDate(market)
  let autoValue = value.split('');
  if (market === "CA") {
    //convert to CA format date
    //case:convert yymd  to YYYY/MM/DD
    if (value && new RegExp(/^\d{2}[1-9][1-9]$/).test(value)) {
      console.log("case1")
      autoValue[3] = `0${autoValue[3]}`;
      autoValue[2] = `0${autoValue[2]}`;
      autoValue[0] = `20${autoValue[0]}`;
    }
    //case:convert yymdd  to yyyymmdd
    if (value && new RegExp(/^\d{2}[1-9][1-3][1-9]$/).test(value)) {
      console.log("case2")
      autoValue[2] = `0${autoValue[2]}`;
       autoValue[0] = `20${autoValue[0]}`;
    }
    // case: convert yyyymd  to yyyymmdd
    if (value && new RegExp(/^[1-9]{1}[0-9]{3}[1-9]{2}$/).test(value)) {
      autoValue[5] = `0${autoValue[5]}`;
      autoValue[4] = `0${autoValue[4]}`;
    }
    //case: convert yyyymdd  to yyyymmdd
    if (value && new RegExp(/^[0-9]{5}[1-3][0-9]$/).test(value)) {
      autoValue[4] = `0${autoValue[4]}`;
    }
  } else {
    // convert to EN fomatdate
    //case:convert mdyy to mmddyy
    if (value && new RegExp(/^[2-9][1-9]\w{2}$/).test(value)) {
      autoValue[0] = `0${autoValue[0]}`;
      autoValue[1] = `0${autoValue[1]}`;
    }
    //case:convert mddyy to mmddyy
    if (value && new RegExp(/^[1-9][0-3][0-9]\w{2}$/).test(value)) {
      autoValue[0] = `0${autoValue[0]}`;
    }
    // case: convert mdyyyy to mmddyyyy
    if (value && new RegExp(/^[1-9][1-9]\w{4}$/).test(value)) {
      autoValue[0] = `0${autoValue[0]}`;
      autoValue[1] = `0${autoValue[1]}`;
    }
    //case: convert mddyyyy to mmddyyyy
    if (value && new RegExp(/^[1-9][1-3][1-9]\w{4}$/).test(value)) {
      autoValue[0] = `0${autoValue[0]}`;
    }
  }
  const fillValue = autoValue.join('')

  if (moment(fillValue, FORMAT_DATE_INPUT).isValid()) {
    return moment(fillValue, FORMAT_DATE_INPUT).format(FORMAT_DATE_INPUT)
  };

  return '';

};export const getIntakeContextSlug=(generation: string) => {
    return generation == 'generation_3.0' ? 'intake-context' : 'inquiry-intake'
}

